

















import UniversalSelectInput from "../form/UniversalSelectInput.vue";
import { createComponent, createElement, ref } from "@vue/composition-api";
import { useActions } from "@/shared/useMegaraxClient";
import { IncompleteResourceItem } from "@megarax/client/src/resources/ResourceItem";
import { Resource } from "@megarax/client/src";
import { ListActions } from "@megarax/client/src/actions";

interface Props {
  value: any;
  resource: Resource<ListActions<any>>;
}

export default createComponent<Props>({
  components: { UniversalSelectInput },
  props: {
    value: { required: true },
    resource: { required: true },
  },
  setup(props, ctx) {
    const items = ref<IncompleteResourceItem[] | null>(null);

    useActions(props.resource)
      .fetchList()
      .then((list) => {
        items.value = list.items;
      });

    return { items };
  },
});
